(function () {
  function waitForGsap(callback, attempts) {
    attempts = attempts || 0;

    if (window.gsap || attempts > 40) {
      callback();
      return;
    }

    window.setTimeout(function () {
      waitForGsap(callback, attempts + 1);
    }, 50);
  }

  function initUk3dReviewsSlider(section) {
    if (!section || section.dataset.uk3dReviewsReady === 'true') {
      return;
    }

    var slides = Array.prototype.slice.call(section.querySelectorAll('.uk3d_reviews_slider__slide'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('.uk3d_reviews_slider__dot'));
    var prev = section.querySelector('.uk3d_reviews_slider__arrow--prev');
    var next = section.querySelector('.uk3d_reviews_slider__arrow--next');
    var stage = section.querySelector('.uk3d_reviews_slider__stage');
    var currentIndex = 0;
    var isAnimating = false;
    var autoplayTimer = null;
    var autoplayEnabled = section.dataset.autoplay === 'true';
    var interval = parseInt(section.dataset.interval, 10) || 6000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!slides.length || !stage) {
      return;
    }

    section.dataset.uk3dReviewsReady = 'true';

    function updateDots(index) {
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle('is_active', dotIndex === index);
      });
    }

    function setSlideState(index) {
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.classList.toggle('is_active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      updateDots(index);
    }

    function makePiece(slide, split, side) {
      var piece = document.createElement('div');
      var clone = slide.cloneNode(true);

      piece.className = 'uk3d_reviews_slider__piece uk3d_reviews_slider__piece--' + split + ' uk3d_reviews_slider__piece--' + side;
      clone.classList.add('is_active');
      clone.setAttribute('aria-hidden', 'true');

      piece.appendChild(clone);

      return piece;
    }

    function goToSlide(nextIndex, direction) {
      if (isAnimating || nextIndex === currentIndex || nextIndex < 0 || nextIndex >= slides.length) {
        return;
      }

      var currentSlide = slides[currentIndex];
      var nextSlide = slides[nextIndex];
      var split = currentSlide.dataset.split || 'vertical';
      var hasGsap = !!window.gsap && !reducedMotion;

      isAnimating = true;
      stopAutoplay();

      if (!hasGsap) {
        currentIndex = nextIndex;
        setSlideState(currentIndex);
        isAnimating = false;
        startAutoplay();
        return;
      }

      var transition = document.createElement('div');
      var pieceA = makePiece(currentSlide, split, 'a');
      var pieceB = makePiece(currentSlide, split, 'b');

      transition.className = 'uk3d_reviews_slider__transition';
      transition.appendChild(pieceA);
      transition.appendChild(pieceB);
      stage.appendChild(transition);

      currentSlide.classList.remove('is_active');
      currentSlide.setAttribute('aria-hidden', 'true');

      nextSlide.classList.add('is_active');
      nextSlide.setAttribute('aria-hidden', 'false');

      updateDots(nextIndex);

      window.gsap.set(nextSlide, {
        autoAlpha: 0,
        scale: 1.04
      });

      if (split === 'horizontal') {
        window.gsap.set(pieceA, {
          transformOrigin: 'center bottom'
        });

        window.gsap.set(pieceB, {
          transformOrigin: 'center top'
        });
      } else {
        window.gsap.set(pieceA, {
          transformOrigin: 'right center'
        });

        window.gsap.set(pieceB, {
          transformOrigin: 'left center'
        });
      }

      var timeline = window.gsap.timeline({
        defaults: {
          duration: 0.95,
          ease: 'power4.inOut'
        },
        onComplete: function () {
          transition.remove();

          window.gsap.set(nextSlide, {
            clearProps: 'opacity,visibility,transform'
          });

          currentIndex = nextIndex;
          setSlideState(currentIndex);
          isAnimating = false;
          startAutoplay();
        }
      });

      timeline.to(nextSlide, {
        autoAlpha: 1,
        scale: 1,
        duration: 0.8,
        ease: 'power2.out'
      }, 0);

      if (split === 'horizontal') {
        timeline.to(pieceA, {
          yPercent: -24,
          rotationX: 28 * direction,
          scale: 1.08,
          opacity: 0
        }, 0);

        timeline.to(pieceB, {
          yPercent: 24,
          rotationX: -28 * direction,
          scale: 1.08,
          opacity: 0
        }, 0.04);
      } else {
        timeline.to(pieceA, {
          xPercent: -24,
          rotationY: -32 * direction,
          scale: 1.08,
          opacity: 0
        }, 0);

        timeline.to(pieceB, {
          xPercent: 24,
          rotationY: 32 * direction,
          scale: 1.08,
          opacity: 0
        }, 0.04);
      }
    }

    function goNext() {
      var nextIndex = currentIndex + 1;

      if (nextIndex >= slides.length) {
        nextIndex = 0;
      }

      goToSlide(nextIndex, 1);
    }

    function goPrev() {
      var nextIndex = currentIndex - 1;

      if (nextIndex < 0) {
        nextIndex = slides.length - 1;
      }

      goToSlide(nextIndex, -1);
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length < 2) {
        return;
      }

      stopAutoplay();

      autoplayTimer = window.setTimeout(function () {
        goNext();
      }, interval);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (next) {
      next.addEventListener('click', function () {
        goNext();
      });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goPrev();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var nextIndex = parseInt(dot.dataset.goTo, 10);

        if (!isNaN(nextIndex)) {
          goToSlide(nextIndex, nextIndex > currentIndex ? 1 : -1);
        }
      });
    });

    stage.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        goNext();
      }

      if (event.key === 'ArrowLeft') {
        goPrev();
      }
    });

    var touchStartX = 0;
    var touchEndX = 0;

    stage.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
    }, {
      passive: true
    });

    stage.addEventListener('touchend', function (event) {
      touchEndX = event.changedTouches[0].screenX;

      if (Math.abs(touchStartX - touchEndX) < 50) {
        return;
      }

      if (touchEndX < touchStartX) {
        goNext();
      } else {
        goPrev();
      }
    }, {
      passive: true
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', startAutoplay);

    setSlideState(currentIndex);
    startAutoplay();
  }

  function initAllUk3dReviewsSliders() {
    var sections = document.querySelectorAll('[data-uk3d-reviews-slider]');

    sections.forEach(function (section) {
      initUk3dReviewsSlider(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    waitForGsap(initAllUk3dReviewsSliders);
  });

  document.addEventListener('shopify:section:load', function (event) {
    waitForGsap(function () {
      initUk3dReviewsSlider(event.target);
    });
  });
})();